import { render, staticRenderFns } from "./Comp48t2.vue?vue&type=template&id=032795c1&scoped=true&"
import script from "./Comp48t2.vue?vue&type=script&lang=js&"
export * from "./Comp48t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp48t2.vue?vue&type=style&index=0&id=032795c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032795c1",
  null
  
)

export default component.exports